import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import LandingPage from "./pages/LandingPage";
import ImpactPage from "./pages/ImpactPage";

function App() {
  const merchantCode = 'BES_US_INCLOVER';

  return (
    <>

      <Switch>
      <Route
          exact
          path={`/impact`}
          key="app-inclover-impact"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        <Route
          path={`/`}
          key="app-inclover-landing"
        >
          <LandingPage merchantCode={merchantCode} />
        </Route>
      </Switch>
    </>
  );
}

export default App;
